import { createContext } from "react";
import { MeResponse } from "../Api/ApiServer";

interface IAuthContext {
    token: string | null | undefined;
    isAuthenticated: boolean;
    isInitialized: boolean;
    login: (token: string, refreshToken: string, isAdmin: boolean, isSuperAdmin: boolean) => void;
    logout: () => void;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    userData: MeResponse | null;

}

export const AuthorizationContext = createContext<IAuthContext>({
    token: null,
    isAuthenticated: false,
    isInitialized: false,
    login: () => { },
    logout: () => { },
    isAdmin: false,
    isSuperAdmin: false,
    userData: null
});